import {
    combineReducers,
    type Reducer,
    type ReducersMapObject,
} from '@reduxjs/toolkit';
import type { UnknownAction } from 'redux';

import type { ReducerManager } from '../types/reducer-manager';
import type {
    AppStateSchema,
    AppStateSchemaKey,
    AppStateSchemaOptionsKey,
} from '../types/state.schema';

// redux types don't work well with exactOptionalPropertyTypes=true
type CombinedReducer = Reducer<
    AppStateSchema,
    UnknownAction,
    Partial<AppStateSchema>
>;

export function createReducerManager(
    initialReducers: ReducersMapObject<AppStateSchema>,
): ReducerManager {
    const reducers = { ...initialReducers };

    let combinedReducer = combineReducers(reducers) as CombinedReducer;
    let keysToRemove: Array<AppStateSchemaOptionsKey> = [];

    return {
        getReducerMap: () => reducers,
        reduce: (state: Undefinable<AppStateSchema>, action: UnknownAction) => {
            let currentState = state;

            if (state && keysToRemove.length > 0) {
                currentState = { ...state };

                keysToRemove.forEach((key) => {
                    delete currentState?.[key];
                });

                keysToRemove = [];
            }

            return combinedReducer(currentState, action);
        },
        add: (key: AppStateSchemaKey, reducer: Reducer) => {
            if (key && !reducers[key]) {
                reducers[key] = reducer;

                combinedReducer = combineReducers(reducers) as CombinedReducer;
            }
        },
        remove: (key: AppStateSchemaOptionsKey) => {
            if (key && reducers[key]) {
                delete reducers[key];

                keysToRemove.push(key);

                combinedReducer = combineReducers(reducers) as CombinedReducer;
            }
        },
    };
}
